import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';

import HoverableCard from '../../MultiLocationSaleModal/HoverableCard';

export const StyledPaymentDepositModal = styled(Modal)`
  width: 531px;
  max-width: 531px;
  min-width: 346px;
`;

export const StyledRequestDepositModal = styled(Modal)`
  width: 670px;
  max-width: 670px;
  min-width: 346px;
`;

export const StyledCancelDepositModal = styled(Modal)`
  width: 401px;
`;

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 500px) {
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

export const StyledCard = styled(HoverableCard)`
  width: 49%;
  height: auto;
  min-height: 132px;
  max-height: 100%;
  align-content: center;
  margin-bottom: 15px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
  > div {
    font-size: 14px;
  }
`;
